
import {mixins} from 'vue-class-component';
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {SolarDataLayer} from '@flashpointbv/solar-datalayer/dist';
import PriceHelper from "../../../../../admin/js/helpers/priceHelper";

@Component({
  name: 'catalog-product-list-item',
  components: ServiceContainer().getComponents(),
})
export default class ProductListItem extends mixins(PriceHelper) {
  @Prop({required: false}) readonly dataSource: string;
  @Prop({required: true}) readonly product: object;
  @Prop({default: null}) readonly type: string | null;
  @Prop({default: 'li'}) readonly componentTag: string;
  @Prop({default: () => []}) private wishlistItems: Array<object>;

  private key: number = 0;

  private get listTypeClass(): string {
    switch (this.type) {
      case 'stock-overview':
        return 'small-24 --stock-overview';
      case 'wishlist':
        return 'small-24 medium-6 cell';
      default:
        return 'small-12 medium-8 cell';
    }
  }

  private get isDiscount() {
    return this.product['final_price_incl_tax'] !== this.product['price_incl_tax'];
  }

    private get imageSrc(): string {
      if (this.product['image'] === 'no_selection' || !this.product.hasOwnProperty('image')) {
        return '/area/web/default/assets/images/logo.svg';
      }
      return `${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:265/h:265/extend:true/background:255:255:255/bl:10.0/q:40/path/media/catalog/product${this.product['image']}`;
    }

  private get imageDataSrc(): string {
    if (this.product['image'] === 'no_selection' || !this.product.hasOwnProperty('image')) {
      return '/area/web/default/assets/images/logo.svg';
    }

    //updatekey because of bug where srcset doesn't get updated
    this.key++;

    return `${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:265/h:265/extend:true/background:255:255:255/path/media/catalog/product${this.product['image']} 1x,
    ${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:530/h:530/extend:true/background:255:255:255/path/media/catalog/product${this.product['image']} 2x`;
  }

  private mounted(): void {
    this.$forceUpdate();
  }

  private updated(): void {
    this.$eventBus.$emit('item-rendered', true);
  }

  private addProductClick(): void {
    SolarDataLayer.init().addSelectItem(this.product, this.$vnode.key as number, 'Product list');
  }

  private get showCta(): boolean {
    switch (this.type) {
      case 'stock-overview':
        return false;
      default:
        return true;
    }
  }

  private get promotionEndTime(): string {
    if (this.product['special_price_end_date'] || null) {
      let date = new Date(this.product['special_price_end_date']);

      return date.toLocaleDateString('nl-NL');
    }

    return  '';
  }
}
